export const VEBYearlyOpenAndCurrentEffectiveDate = {
	veb_current_effective_date_YYYYMMDD: "2025-04-01",
	veb_yearly_open_effective_date_YYYYMMDD: "2025-05-01",
	veb_current_effective_date_MMDDYYYY: "04-01-2025",
	veb_yearly_open_effective_date_MMDDYYYY: "05-01-2025"
};
